import {memo} from 'react';
import styled from 'styled-components';
import {TextHeading5} from '../../text/TextHeading5';

const StyledButton = styled.button<{isDisabled?: boolean}>`
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: white;
  background-image: none;
  border: 1px solid #747775;
  -webkit-border-radius: 20px;
  border-radius: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #1f1f1f;
  cursor: ${({isDisabled}) => (isDisabled ? 'default' : 'pointer')};
  font-family: 'Roboto', arial, sans-serif;
  font-size: 14px;
  height: 48px;
  letter-spacing: 0.25px;
  outline: none;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  text-align: center;
  -webkit-transition:
    background-color 0.218s,
    border-color 0.218s,
    box-shadow 0.218s;
  transition:
    background-color 0.218s,
    border-color 0.218s,
    box-shadow 0.218s;
  vertical-align: middle;
  white-space: nowrap;
  width: 100%;
  max-width: 400px;
  min-width: min-content;

  &:disabled {
    cursor: default;
    background-color: #ffffff61;
    border-color: #1f1f1f1f;
  }

  &:not(:disabled):active .button-state,
  &:not(:disabled):focus .button-state {
    background-color: #303030;
    opacity: 12%;
  }

  &:not(:disabled):hover {
    -webkit-box-shadow:
      0 1px 2px 0 rgba(60, 64, 67, 0.3),
      0 1px 3px 1px rgba(60, 64, 67, 0.15);
    box-shadow:
      0 1px 2px 0 rgba(60, 64, 67, 0.3),
      0 1px 3px 1px rgba(60, 64, 67, 0.15);
  }

  &:not(:disabled):hover .button-state {
    background-color: #303030;
    opacity: 8%;
  }
`;

const ButtonState = styled.div`
  -webkit-transition: opacity 0.218s;
  transition: opacity 0.218s;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

const ButtonContentWrapper = styled.div`
  -webkit-align-items: center;
  align-items: center;
  display: flex;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;
`;

const ButtonIcon = styled.div`
  height: 20px;
  margin-right: 12px;
  min-width: 20px;
  width: 20px;
  flex-shrink: 0;
`;

const OutlookIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    style={{display: 'block'}}>
    <path
      fill="#1976D2"
      d="M28 13h14.533C43.343 13 44 13.657 44 14.467v19.066c0 .81-.657 1.467-1.467 1.467H28V13z"
    />
    <path
      fill="#1E88E5"
      d="M28 6h14.533C43.343 6 44 6.657 44 7.467V14H28V6z"
    />
    <path fill="#1565C0" d="M28 35h16v6.533c0 .81-.657 1.467-1.467 1.467H28V35z" />
    <path
      fill="#2196F3"
      d="M27 44L4 41V7l23-3v40z"
    />
    <path
      fill="#FFF"
      d="M15.5 16c-3.59 0-6.5 3.58-6.5 8s2.91 8 6.5 8 6.5-3.58 6.5-8-2.91-8-6.5-8zm0 13c-1.93 0-3.5-2.24-3.5-5s1.57-5 3.5-5 3.5 2.24 3.5 5-1.57 5-3.5 5z"
    />
  </svg>
);

interface OutlookButtonProps {
  onClick: () => void;
  label: string;
  isDisabled?: boolean;
}

export const OutlookButton = memo(
  ({label, onClick, isDisabled = false}: OutlookButtonProps) => {
    return (
      <StyledButton
        onClick={isDisabled ? undefined : onClick}
        disabled={isDisabled}
        isDisabled={isDisabled}>
        <ButtonState className="button-state" />
        <ButtonContentWrapper>
          <ButtonIcon>
            <OutlookIcon />
          </ButtonIcon>
          <TextHeading5
            center
            text={label}
            style={{
              flexGrow: 1,
              fontSize: 14,
              WebkitFlexGrow: 1,
              marginLeft: -32, // Offset by icon width (20px) + margin (12px)
            }}
          />
        </ButtonContentWrapper>
      </StyledButton>
    );
  },
);


